import { useAppSelector } from '../../../../../stores/redux.store';

export const useSignupVerifyEmailOtpState = () => {
  const email = useAppSelector(state => state.verifyEmailOtp.email);

  return {
    email,
  };
};
